// react
import { fromJS } from "immutable";
import PropTypes from "prop-types";
import React from "react";

// components
import SelectInput from "../../../components/Inputs/SelectInput";

// styles
import css from "./Log.module.scss";

const Filters = (props) => {
	const { filters, setQueryState } = props;

	const results = fromJS([
		{ id: "all", label: "All" },
		{ id: "completed", label: "Completed" },
		{ id: "completedWithErrors", label: "Completed with Errors" },
		{ id: "failed", label: "Failed" },
		{ id: "pendingDeactivation", label: "Pending Deactivation" },
		{ id: "processing", label: "Processing" },
	]);

	const handleSelectChange = (value) => {
		setQueryState([
			{
				param: "status",
				value,
			},
		]);
	};

	return (
		<div className={css.logDetailsfilters}>
			<div className={css.filterLabel}>Status</div>
			<SelectInput onChange={handleSelectChange} value={filters.status} results={results} />
		</div>
	);
};

Filters.propTypes = {
	setQueryState: PropTypes.func.isRequired,
	filters: PropTypes.object.isRequired,
};

export default Filters;
